import { ErrorOutlined } from '@mui/icons-material'
import { Page } from 'Common/Page/Page'
import { Box, Typography } from '@mui/material'

type ErrorProps = {
  message?: string
}

export const ErrorDisplay = ({ message }: ErrorProps) => {
  return (
    <Page center>
      <Box display="flex" flexDirection="column">
        <ErrorOutlined />
        {message && (
          <Box display="flex">
            <Typography variant="body2">{message}</Typography>
          </Box>
        )}
      </Box>
    </Page>
  )
}
